export const filterByString = (str = '', criteria) => str.toLocaleLowerCase().indexOf(criteria.toLocaleLowerCase()) > -1;
export const filterListBy = (list) => (criteria) => {
    if (criteria > -1) {
        return list && list.indexOf(+criteria) > -1;
    }
    return true;
};
export const filterById = (id, criteria) => {
    if (criteria > -1) {
        return id === criteria;
    }
    return true;
};
//# sourceMappingURL=selectors.js.map